import { render } from "./OrderItemStateMap.vue?vue&type=template&id=ed22095c&scoped=true"
import script from "./OrderItemStateMap.vue?vue&type=script&lang=js"
export * from "./OrderItemStateMap.vue?vue&type=script&lang=js"

import "./OrderItemStateMap.vue?vue&type=style&index=0&id=ed22095c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed22095c"]])

export default __exports__
import QChip from 'quasar/src/components/chip/QChip.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QChip,QTooltip,QIcon,QBtn});
